﻿import { FC } from 'react';
import { Section, Card, CardTitle, CardDescription, Button } from '../components/ui';
import { SEOHead } from '../components/seo';
import { ROUTES } from '../config/routes';
import { PageProps } from './HomePage';

export const NotFoundPage: FC<PageProps> = ({ onNavigate }) => {
  return (
    <>
      <SEOHead title="Page Not Found" noIndex={true} />
      <Section title="404 — Page Not Found">
        <div style={{ maxWidth: '500px', margin: '0 auto', textAlign: 'center' }}>
          <Card>
            <CardTitle>Route Not Found</CardTitle>
            <CardDescription style={{ marginTop: '0.5rem' }}>
              The page or resource you requested does not exist in our route table.
            </CardDescription>
            <div style={{ marginTop: '1.5rem' }}>
              <Button variant="primary" onClick={() => onNavigate(ROUTES.HOME)}>
                Back to Home
              </Button>
            </div>
          </Card>
        </div>
      </Section>
    </>
  );
};


